// 4x6 cards are postcards: their backs are authored landscape (6x4) while fronts are
// portrait, so an exact-orientation dimension match comes up empty for them.
export const isPostcardDimensions = (dimensions: Readonly<{ width: number; height: number }>): boolean => {
  return (dimensions.width === 4 && dimensions.height === 6) || (dimensions.width === 6 && dimensions.height === 4);
};

type SelectBackTemplatesArgs<T> = Readonly<{
  exactOrientation: ReadonlyArray<T>;
  rotatedOrientation: ReadonlyArray<T>;
  /** The exact-orientation query has completed (not merely returned no data yet). */
  exactQueryCompleted: boolean;
  isPostcardSize: boolean;
}>;

// Exact-orientation backs always win. Rotated backs apply only for postcard sizes, and only
// once the exact query has completed empty — while it is still loading, rotated results must
// not win (they could get pinned onto new drafts by the placeholder-default effect).
export const selectBackTemplates = <T>(args: SelectBackTemplatesArgs<T>): ReadonlyArray<T> => {
  const { exactOrientation, rotatedOrientation, exactQueryCompleted, isPostcardSize } = args;
  if (exactOrientation.length > 0) return exactOrientation;
  if (!isPostcardSize || !exactQueryCompleted) return [];
  return rotatedOrientation;
};
